module.exports = "/_next/static/images/ff6afc8c60fc0ef6e799ac6e8f35432d-rewards-app-lg@2x.png";